/* eslint-disable no-invalid-this */
const NS = 'FindCoursesBlock';
const CLS = 'findCoursesBlock';

import { animateScrollRevealMixinBlock } from '../../mixins/animateScrollRevealMixinBlock/animateScrollRevealMixinBlock';

export class FindCoursesBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		// Form Submit
		this.$submitButton = this.$element.find(`.${CLS}-form-submit-button`);
		this.$submitButton.on('click', (e) => {
			e.preventDefault();

			// Chosen courses
			const courses = [];
			let coursesStr = '';
			$.each($('input:checkbox:checked', $(`.${CLS}-nav-toggle-group`)), function() {
                courses.push($(this).val());
            });
			coursesStr = courses.length ? courses.join('&') : 'nothing selected';
		});

		this.initAnimateScrollReveal(this, CLS);
	}
}

Object.assign(FindCoursesBlock.prototype, animateScrollRevealMixinBlock);
